
// 创建一个 Result 对象
export const Result = {
  // 显示 result，每次调用都会创建新元素并插入
  show(options = {}) {
    const {
      content = '', // 内容，可以是文本或 HTML
      allowHtml = false, // 是否渲染为 HTML，默认为 false（普通文本）
      className = '', // 自定义类名
      target = document.body, // 插入的目标元素，默认为 document.body
    } = options
    // 创建新的容器元素
    const container = document.createElement('div')
    // 设置类名，始终包含 hdm-result，如果有自定义类名则拼接
    container.className = className ? `hdm-result ${className}` : 'hdm-result'
    // 根据 allowHtml 参数决定渲染方式
    if (allowHtml) {
      // HTML 渲染
      container.innerHTML = content
    } else {
      // 普通文本渲染
      const textNode = document.createTextNode(content)
      container.appendChild(textNode)
    }
    // 直接插入到目标元素
    target.appendChild(container)
    // 返回创建的元素，方便调用者在需要时操作
    return container
  },
}
